import dayjs from 'dayjs';

export const dayToName = (day: number) => {
  switch (day) {
    case 0:
      return 'SUN';
    case 1:
      return 'MON';
    case 2:
      return 'TUE';
    case 3:
      return 'WED';
    case 4:
      return 'THU';
    case 5:
      return 'FRI';
    case 6:
      return 'SAT';
  }
};

export const monthToName = (month: number) => {
  switch (month) {
    case 0:
      return 'Jan';
    case 1:
      return 'Feb';
    case 2:
      return 'Mar';
    case 3:
      return 'Apr';
    case 4:
      return 'May';
    case 5:
      return 'Jun';
    case 6:
      return 'Jul';
    case 7:
      return 'Aug';
    case 8:
      return 'Sep';
    case 9:
      return 'Oct';
    case 10:
      return 'Nov';
    case 11:
      return 'Dec';
  }
};

export const monthToFullName = (month: number) => {
  switch (month) {
    case 0:
      return 'January';
    case 1:
      return 'February';
    case 2:
      return 'March';
    case 3:
      return 'April';
    case 4:
      return 'May';
    case 5:
      return 'June';
    case 6:
      return 'July';
    case 7:
      return 'August';
    case 8:
      return 'September';
    case 9:
      return 'October';
    case 10:
      return 'November';
    case 11:
      return 'December';
  }
};

export const calculateNumberOfNights = (
  start_date: string,
  end_date: string
): number => {
  const startDate = new Date(start_date);
  const endDate = new Date(end_date);

  const timeDifference = endDate.getTime() - startDate.getTime();

  const nights = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  return nights;
};

export function isSameDate(date1: string, date2: string): boolean {
  const dateOnly1 = dayjs(new Date(date1)).format('YYYY-MM-DD');
  const dateOnly2 = dayjs(new Date(date2)).format('YYYY-MM-DD');

  return dateOnly1 === dateOnly2;
}

export function getDatesBetween(
  startDateStr: string,
  endDateStr: string,
  isGetNight: boolean = false
): string[] {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const dates: string[] = [];
  let currentDate = new Date(startDate);

  if (isGetNight) {
    while (currentDate < endDate) {
      dates.push(dayjs(new Date(currentDate)).format('YYYY-MM-DD'));
      currentDate.setDate(currentDate.getDate() + 1);
    }
  } else {
    while (currentDate <= endDate) {
      dates.push(dayjs(new Date(currentDate)).format('YYYY-MM-DD'));
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  return dates;
}
